import { Breadcrumb } from "antd";

const MyBreadcrumb = ({ title1, title2, title3 }: { title1: string; title2: string; title3?: string }) => {
	return (
		<div className="container mb-24 mt-12">
			<Breadcrumb
				items={[
					{
						title: <p className="line-clamp-1 font-bold">{title1}</p>,
					},
					{
						title: <p className="line-clamp-1 font-bold">{title2}</p>,
					},
					...(title3
						? [
								{
									title: <p className="line-clamp-1 font-bold">{title3}</p>,
								},
							]
						: []),
				]}
			/>
		</div>
	);
};

export default MyBreadcrumb;
